import { createContext } from 'react';
import { observable, makeObservable } from 'mobx';
import remotedev from 'mobx-remotedev';
import { AppStore } from './app';
import { UsersStore } from './users';
import { AuthStore } from './auth';
import { PartsStore } from './parts';
import { BrandStore } from './brand';
import { RegionStore } from './region';
import { LanguageStore } from './languages';
import { RecycleStore } from './recycle';
import { StaticAssetStore } from './staticAssets';
import { PatternStore } from './patterns';
import { UsersRegions } from './userRegions';
import { UsersActivityReport } from './report';

export class RootStore {
  AppStore: AppStore;
  UsersStore: UsersStore;
  AuthStore: AuthStore;
  PartsStore: PartsStore;
  BrandStore: BrandStore;
  RegionStore: RegionStore;
  LanguageStore: LanguageStore;
  RecycleStore: RecycleStore;
  StaticAssetStore: StaticAssetStore;
  PatternStore: PatternStore;
  UsersRegions: UsersRegions;
  UsersActivityReport: UsersActivityReport;

  version = 1;

  constructor() {
    makeObservable(this, {
      version: observable
    });

    this.AppStore = new AppStore(this);
    this.UsersStore = new UsersStore(this);
    this.UsersRegions = new UsersRegions(this);
    this.AuthStore = new AuthStore(this);
    this.PartsStore = new PartsStore(this);
    this.BrandStore = new BrandStore(this);
    this.RegionStore = new RegionStore(this);
    this.UsersActivityReport = new UsersActivityReport(this);
    this.PatternStore = new PatternStore(); // (this) Root store bindings not needed.
    this.LanguageStore = new LanguageStore(); // (this) Root store bindings not needed.
    this.RecycleStore = new RecycleStore(); // (this) Root store bindings not needed.
    this.StaticAssetStore = new StaticAssetStore(); // (this) Root store bindings not needed.
  }
}

export const rootStore = (() => {
  const store = remotedev(RootStore, {
    global: true,
    onlyActions: true,
    name: 'reflek'
  });
  return new store();
})();

export const rootContext = createContext(rootStore);
